export const createServicesStepSpecificPropertiesSlice = (_set, _get) => ({});
